import React from 'react';
// Typed
import profile from '../asset/img/profile.jpg'
import Typed from "react-typed";
const Header = () => {

    const whatsapp = ()=>{
        window.open("https://api.whatsapp.com/send?phone=50375511863&text=Hola%20Rafa%20me%20gustó%20tu%20portafolio%20", "_blank")
      }

    return (
        <div className="padding">
        <div className="main-info">
            <span className="span-Hey mt-5">Hola, mi nombre es</span>
            <h1 className="nombre">RAFAEL MARTINEZ</h1>
            <img
            className="img-fluid profile-img mb-2"
            src={profile}
            alt="Perfil"
          
          ></img>
          {/* <h1 style={{color:'white'}}>Habiliades desarrolladas</h1> */}
            <h3 className="typed-spam"><Typed
                className="typed-text ml-2"
                strings={["Full Stack developer", "Front-end developer", "Back-end developer", "Database Analyst", "Freelancer"]}
                typeSpeed={25}
                backSpeed={50}
                loop
            />
            </h3>
        
            <a className="btn-main-offer mt-4" onClick={whatsapp}>Contacto</a>
        </div>
        </div>
    )
}

export default Header
